import * as model from './model';

export const surcharge = {
  model,
};
